import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';

import api from "./../../service/api";
import { formatCurrency, formatDate } from "./../../service/format";
import InputDecimal from "../../components/InputDecimal";
const TrafficTicket = () => {
    let emptyTrafficTicket = {
        date_ticket: "",
        due_date: null,
        auto: null,
        reason: '',
        location: null,
        truck: null,
        driver: null,
        amount: null,
        allocation: 'driver',
        create_expense: true
    };

    const allocationOptions = [
        { id: 'driver', label: 'Motorista' },
        { id: 'company', label: 'Empresa' },
    ]

    const chooseOptions = {label: 'Selecionar a imagem do auto', icon: 'pi pi-fw pi-plus'};

    const [trafficsTicket, setTrafficsTicket] = useState([]);
    const [trafficTicketDialog, setTrafficTicketDialog] = useState(false);
    const [deleteTrafficTicketDialog, setDeleteTrafficTicketDialog] = useState(false);
    const [trafficTicket, setTrafficTicket] = useState(emptyTrafficTicket);

    const [drivers, setDrivers] = useState([]);
    const [trucks, setTrucks] = useState([]);

    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _trafficTicket = { ...trafficTicket };
        _trafficTicket[`${name}`] = val;

        setTrafficTicket(_trafficTicket);
    };

    const openNew = () => {
        setTrafficTicket(emptyTrafficTicket);
        setSubmitted(false);
        setTrafficTicketDialog(true);
        setDisabled(false);
    };

    const hideDialog = () => {
        setSubmitted(false);
        setTrafficTicketDialog(false);
        setDisabled(false);
    };

    const hideDeleteTrafficTicketDialog = () => {
        setDeleteTrafficTicketDialog(false);
    };

    const editTrafficTicket = (trafficTicket) => {
        setTrafficTicket({ ...trafficTicket });
        setTrafficTicketDialog(true);
    };

    const confirmDeleteTrafficTicket = (trafficTicket) => {
        setTrafficTicket({ ...trafficTicket });
        setDeleteTrafficTicketDialog(true);
    };

    const handleTrafficTicket = () => {
        if (!trafficTicket.date_ticket || !trafficTicket.truck || !trafficTicket.amount) return setSubmitted(true);

        setSubmitted(false);
        setDisabled(true);

        var _trafficTicket = {...trafficTicket};

        _trafficTicket['date_ticket'] = new Date(_trafficTicket.date_ticket).getTime();

        if(_trafficTicket.due_date)
            _trafficTicket['due_date'] = new Date(_trafficTicket.due_date).getTime();

        var uri = _trafficTicket.code ? "/trafficticket/update" : "/trafficticket/create";
        api()
            .post(uri, _trafficTicket)
            .then((response) => {
                if (response.status === 200 && response.data.result) {
                    toast.current.show({ severity: "success", summary: "Sucesso", detail: response.data.message });
                    listTrafficTickets();
                    hideDialog();
                } else {
                    toast.current.show({ severity: "warn", summary: "Atenção", detail: response.data.message });
                    setDisabled(false);
                }
            });
    };

    const handleDeleteTrafficTicket = () => {
        setDeleteTrafficTicketDialog(false);
        api()
            .delete("/trafficticket/" + trafficTicket.code)
            .then((response) => {
                if (response.status === 200 && response.data.result) {
                    toast.current.show({ severity: "success", summary: "Sucesso", detail: response.data.message });
                    listTrafficTickets();
                } else toast.current.show({ severity: "error", summary: "Erro", detail: response.data.message });
                setTrafficTicket(emptyTrafficTicket);
            });
    };

    const listTrafficTickets = () => {
        api()
            .get("/trafficticket/list")
            .then((response) => {
                if (response.status === 200 && response.data.result) {
                    setTrafficsTicket(response.data.data);
                }
            });
    };

    const listTrucks = () => {
        api()
            .get("truck/list")
            .then((response) => {
                if (response.status === 200 && response.data.result) {
                    setTrucks(response.data.data);
                }
            });
    };

    const listDrivers = () => {
        api()
            .get("/driver/list")
            .then((response) => {
                if (response.status === 200 && response.data.result) {
                    setDrivers(response.data.data);
                }
            });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Nova" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mt-2 mr-2" onClick={() => confirmDeleteTrafficTicket(rowData)} />
                <Button icon="pi pi-ellipsis-v" className="p-button-rounded p-button-info" onClick={() => editTrafficTicket(rowData)} />
            </div>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciar Multas</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" onClick={handleTrafficTicket} loading={disabled} icon="pi pi-check" className="p-button-text" />
        </>
    );
    const deleteTrafficTicketDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteTrafficTicketDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteTrafficTicket} />
        </>
    );

    useEffect(() => {
        listTrafficTickets();
        listDrivers();
        listTrucks();
    }, []);

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>

                    <DataTable
                        ref={dt}
                        value={trafficsTicket}
                        dataKey="id"
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25]}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter}
                        emptyMessage="Nenhum registro encontrado."
                        header={header}
                        responsiveLayout="scroll"
                    >
                        <Column field="date_ticket" body={rowData => formatDate(rowData.date_ticket, false)} header="Data da Multa"></Column>
                        <Column field="auto"  header="Auto de infração" ></Column>
                        <Column field="allocation" body={rowData => rowData.allocation === 'driver' ? 'Motorista' : 'Empresa'} header="Alocação"></Column>
                        <Column field="driverName"  header="Motorista" ></Column>
                        <Column field="plate" header="Caminhão" sortable></Column>
                        <Column body={(rowData) => (rowData.amount || 0 ? formatCurrency(rowData.amount, true) : "-")} header="Valor" sortable></Column>
                        <Column field="due_date" body={rowData => rowData.due_date ? formatDate(rowData.due_date, false) : '-'} header="Data de Vencimento"></Column>
                        <Column body={actionBodyTemplate} style={{ whiteSpace: 'nowrap' }}></Column>
                    </DataTable>

                    <Dialog visible={trafficTicketDialog} style={{ width: "450px" }} header="Multa" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="reason">Auto de infração</label>
                                <InputText rows={3} value={trafficTicket.auto} onChange={(e) => onInputChange(e, 'auto')} />
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="date">Data</label>
                                <Calendar id="date" dateFormat='dd/mm/yy' locale='pt-br' value={trafficTicket.date_ticket ? new Date(trafficTicket.date_ticket) : null} onChange={(e) => onInputChange(e, 'date_ticket')} showIcon />
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="duedate">Data do Vencimento</label>
                                <Calendar id="duedate" dateFormat='dd/mm/yy' locale='pt-br' value={trafficTicket.due_date ? new Date(trafficTicket.due_date) : null} onChange={(e) => onInputChange(e, 'due_date')} showIcon />
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="reason">Motivo</label>
                                <InputTextarea rows={3} value={trafficTicket.reason} onChange={(e) => onInputChange(e, 'reason')} />
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="reason">Localização</label>
                                <InputText rows={3} value={trafficTicket.localization} onChange={(e) => onInputChange(e, 'localization')} />
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="truck">Caminhão</label>
                                <Dropdown value={trafficTicket.truck} id="truck" options={trucks} onChange={(e) => onInputChange(e, "truck")} optionLabel="plate" optionValue="code" placeholder="Selecione o caminhão" />
                                {submitted && !trafficTicket.truck && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                            </div>
                        </div>

                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="driver">Motorista</label>
                                <Dropdown value={trafficTicket.driver} id="driver" options={drivers} onChange={(e) => onInputChange(e, "driver")} optionLabel="name" optionValue="code" placeholder="Selecione o motorista" />
                            </div>
                        </div>

                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="driver">Alocação</label>
                                <Dropdown value={trafficTicket.allocation} id="driver" options={allocationOptions} onChange={(e) => onInputChange(e, "allocation")} optionLabel="label" optionValue="id" placeholder="Selecione a locação" />
                            </div>
                        </div>

                        <div className="field">
                            <label htmlFor="amount">Valor</label>
                            <InputDecimal disabled={disabled} id="amount" mode="currency" value={trafficTicket.amount} onChange={(e) => onInputChange(e, "amount")} />
                            {submitted && !trafficTicket.amount && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                        </div>
                        {!trafficTicket.expense ? (
                            <div className="field-checkbox">
                                <hr />
                                <Checkbox disabled={disabled} tooltip="" inputId="withOut" checked={trafficTicket.create_expense} onChange={e => {
                                    var  _trafficTicket = { ...trafficTicket};
                                    _trafficTicket['create_expense'] = e.checked;
                                    setTrafficTicket(_trafficTicket);
                                }} />
                                <label htmlFor="">
                                    Gerar Despesa
                                </label>
                            </div>
                        ) : <></>}
                        
                    </Dialog>

                    <Dialog visible={deleteTrafficTicketDialog} style={{ width: "450px" }} header="Atenção" modal footer={deleteTrafficTicketDialogFooter} onHide={hideDeleteTrafficTicketDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem" }} />
                            {trafficTicket && <span>Você tem certeza que deseja remover essa multa? Despensa vinculada a esta multa, caso exista, também será excluída.</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );
};

export default TrafficTicket;
